// @mui
import { ListItemButtonProps, ListSubheaderProps, Divider } from '@mui/material';
// hooks
import useLocales from '../../../hooks/useLocales';
// guards
import PermissionGuard from '../../../guards/PermissionGuard';
//
import { NavSubheaderProps } from '../type';
import { ListItemStyle, ListItemTextStyle, ListItemIconStyle, ListSubheaderStyle } from './style';

// ----------------------------------------------------------------------

type Props = NavSubheaderProps & ListSubheaderProps;

export default function NavItem({ subheader, permissions, isCollapse, ...other }: Props) {
  const { t } = useLocales();

  const renderContent = (
    <ListSubheaderStyle
      sx={{
        ...(isCollapse && {
          opacity: 0,
        }),
      }}
    >
      {t(subheader)}
    </ListSubheaderStyle>
  );

  return <PermissionGuard permissions={permissions}>{renderContent}</PermissionGuard>;
}